import { configureStore } from '@reduxjs/toolkit';
import { Provider } from "react-redux";

import DatahubApplication from './sc-datahub';
import userReducer from './sc-datahub/Reducers/user-reducer';
import homepageReducer from './sc-datahub/Reducers/homepage-reducer';
import companyDetailsReducer from './sc-datahub/Reducers/company-details-reducer';
import supplierDetailsReducer from './sc-datahub/Reducers/supplier-details-reducer';
import customerDetailsReducer from './sc-datahub/Reducers/customer-details-reducer';
import aboutPageReducer from './sc-datahub/Reducers/about-page-reducer';
import authReducer from './sc-datahub/Reducers/auth-reducer';


const store = configureStore(
  {
      reducer:
      {
          user: userReducer,
          details : homepageReducer,
          company_details : companyDetailsReducer,
          supplier_details: supplierDetailsReducer,
          customer_details: customerDetailsReducer,
          company_info : aboutPageReducer,
          auth: authReducer
      }
  });

  // function OutageBanner() {
  //   return (
  //     <div
  //       style={{
  //         background: "#ffcccc",
  //         color: "#660000",
  //         padding: "1rem",
  //         textAlign: "center",
  //         fontWeight: "bold",
  //       }}
  //     >
  //       We are currently experiencing a temporary outage. Please check back soon!
  //     </div>
  //   );
  // }

  
function App() {
  return (
    <Provider store={store}>
        <DatahubApplication></DatahubApplication>
        {/* <OutageBanner /> */}
    </Provider>
  );
}

export default App;
